@if (!emailSent) {
    <div class="recovery-viewport w-100 bc-mono-white b-logo" fxLayout="column">
        <div fxLayout="column" fxLayoutAlign="start center" class="recovery-center w-100">
            <div fxLayout="column" fxLayoutAlign="start stretch"
                 class="recovery-card p-32 main-shadow radius-16">
                <div class="h2-semi-bold c-primary-gray-900 text-center">
                    {{ 'i18n_af_passwordRecoveryTitle' | translate }}
                </div>
                @if (form) {
                    <form [formGroup]="form"
                          (submit)="submit()"
                          fxLayout="column"
                          fxLayoutAlign="start stretch"
                          class="mt-24"
                          autocomplete="off">
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelRecoveryMethod' | translate }}</div>
                            <mat-form-field class="w-100 mt-4">
                                <mat-select formControlName="method"
                                            hideSingleSelectionIndicator
                                            [placeholder]="'i18n_af_placeholderRecoveryMethod' | translate">
                                    <mat-option [value]="EMAIL_METHOD">{{ 'i18n_af_recoveryMethodEmail' | translate }}</mat-option>
                                    <mat-option [value]="BIOMETRIC_METHOD">{{ 'i18n_af_recoveryMethodBiometric' | translate }}</mat-option>
                                </mat-select>
                                <ui-kit-svg matSuffix class="i-16 mr-16 pointer c-primary-gray-600" name="ic_arrow_down"/>
                            </mat-form-field>
                        </div>
                        @if (form.controls.method.value === EMAIL_METHOD) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-16">
                                <div class="t5 c-primary-gray-600">{{ 'i18n_af_login' | translate }}*</div>
                                <mat-form-field class="w-100 mt-4">
                                    <input matInput formControlName="login" name="login"/>
                                    @if (form.controls.login.hasError('recoveryError')) {
                                        <mat-error class="t5 c-secondary-red-800">{{ recoveryErrorKey | translate }}</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                        @if (form.controls.method.value === BIOMETRIC_METHOD) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-16">
                                <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelIin' | translate }}*</div>
                                <mat-form-field class="w-100 mt-4">
                                    <input matInput formControlName="iin" name="iin" mask="000000000000"/>
                                    @if (form.controls.iin.hasError('recoveryError')) {
                                        <mat-error class="t5 c-secondary-red-800">{{ recoveryErrorKey | translate }}</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                        @if (form.controls.method.value) {
                            @if (form.controls.login.hasError('recoveryError') || form.controls.iin.hasError('recoveryError')) {
                                <af-support-notice class="w-100 mt-8"
                                                   accentText="i18n_af_passwordRecoveryUserNotFoundWarningAccent"
                                                   warningText="i18n_af_passwordRecoveryUserNotFoundWarning"/>
                            }
                            <div class="mt-32" fxLayout="row" fxLayoutAlign="center center">
                                <ui-kit-button [disabled]="form.invalid"
                                               type="primary"
                                               spinnerId="submit"
                                               label="{{ (form.controls.method.value === BIOMETRIC_METHOD ? 'i18n_af_buttonNext' : 'i18n_af_buttonSend') | translate }}"/>
                            </div>
                        }
                        <ui-kit-button class="mt-16"
                                       type="text"
                                       buttonType="button"
                                       color="accent"
                                       label="{{ 'i18n_af_buttonCancel' | translate }}"
                                       (clickListener)="cancel()"/>
                    </form>
                }
            </div>
        </div>
    </div>
} @else {
    <af-recovery-status iconType="success"
                        titleText="i18n_af_passwordRecoveryEmailSentTitle"
                        subtitleText="i18n_af_passwordRecoveryEmailSentSubtitle"/>
}
